import { render } from "./PatientTag.vue?vue&type=template&id=13451c1d"
import script from "./PatientTag.vue?vue&type=script&lang=js"
export * from "./PatientTag.vue?vue&type=script&lang=js"

import "./PatientTag.vue?vue&type=style&index=0&id=13451c1d&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__